import { render } from "./paymentPageUplift.vue?vue&type=template&id=1730902d&scoped=true"
import script from "./paymentPageUplift.vue?vue&type=script&lang=js"
export * from "./paymentPageUplift.vue?vue&type=script&lang=js"

import "./paymentPageUplift.vue?vue&type=style&index=0&id=1730902d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1730902d"]])

export default __exports__